module.exports = __webpack_public_path__ + "img/button-acheter.6e18a5e3.png";